import { render, staticRenderFns } from "./teacher.vue?vue&type=template&id=55ec22ae"
import script from "./teacher.vue?vue&type=script&lang=js"
export * from "./teacher.vue?vue&type=script&lang=js"
import style0 from "./teacher.vue?vue&type=style&index=0&id=55ec22ae&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports